"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isHBSFile = isHBSFile;
exports.isJSFile = isJSFile;
exports.isSupportedFileType = isSupportedFileType;
exports.normalizePath = normalizePath;
exports.serializePath = serializePath;

var _path = require("path");

function serializePath(file) {
  return file.split(_path.sep).join("/");
}

function normalizePath(file) {
  return file.split("/").join(_path.sep);
}

function isJSFile(relativePath) {
  return relativePath.endsWith(".js");
}

function isHBSFile(relativePath) {
  return relativePath.endsWith(".hbs");
}

function isSupportedFileType(relativePath) {
  return isJSFile(relativePath) || isHBSFile(relativePath);
}